import { createEffect } from "effector";
import { toast } from "react-toastify";


export const showSuccessToastFx = createEffect<string, void>({
  handler: (message) => {
    toast.success(message, { containerId: 'toasts__container' });
  },
});